import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { clsx } from 'clsx';

import { RealtimeProvider } from 'providers/RealtimeProvider';

import { TeacherMenu } from './components';
import { ModeratorCommentBanner } from './components/ModeratorCommentBanner';
import { TutorProfileCompletionBanner } from './components/TutorProfileCompletionBanner';
import { PassportVerificationBanner } from './components/PassportVerificationBanner';
import classes from './Teacher.module.scss';

export const Teacher = () => {
  const location = useLocation();
  const isChat = location.pathname.startsWith('/teacher/chat');

  useEffect(() => {
    document.documentElement.classList.add('role-teacher');
    return () => {
      document.documentElement.classList.remove('role-teacher');
    };
  }, []);

  return (
    <div className={classes.container}>
      <RealtimeProvider>
        <div className={clsx(classes.root, isChat && classes['root--chat'])}>
          <TeacherMenu />
          <div className={classes['teacher-content']}>
            <TutorProfileCompletionBanner />
            <PassportVerificationBanner />
            <ModeratorCommentBanner />
            <Outlet />
          </div>
        </div>
      </RealtimeProvider>
    </div>
  );
};

export const TeacherLayout = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className={classes.container}>
      <div className={classes.root}>{children}</div>
    </div>
  );
};
